export const environments = {
  production: false,
  baseUrl: 'https://synergen.trigma.us/api/',
  secondaryUrl: 'https://synergen-api.trigma.us/',
  ngRok: 'wss://synergen-api.trigma.us/ws',
  checkSessionApi: 'https://auth-synergen.trigma.us/api/session',
  loginPortalUrl: '',
  sghAuth: {
    clientId: 'angular-client',
    issuer: 'https://auth-synergen.trigma.us',
    redirectUri: 'https://synergen-front.trigma.us/auth/callback',
    postLogoutRedirectUri: 'https://synergen-front.trigma.us/',
    pkce: true,
  },
};
